import React from 'react';
import { HomePage } from './HomePage';

export function EnglishHome({ search = '' }: { search?: string }) {
  return <HomePage locale="en" search={search} />;
}
